import { render, staticRenderFns } from "./after-payment.vue?vue&type=template&id=96936192&scoped=true&"
import script from "./after-payment.vue?vue&type=script&lang=js&"
export * from "./after-payment.vue?vue&type=script&lang=js&"
import style0 from "./after-payment.vue?vue&type=style&index=0&id=96936192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96936192",
  null
  
)

export default component.exports